import React, { useEffect, useRef } from "react";

const Checkbox = (props) => {
  const { checked, value, onChange } = props;

  const checkboxRef = useRef(null);

  useEffect(() => {
    checkboxRef.current.checked = checked;
  }, [checked]);

  return (
    <input ref={checkboxRef} className="checkbox custom-checkbox" type="checkbox" value={value} onChange={onChange} />
  );
}

export default Checkbox;